<template>
  <div class="bi-chart-empty">
    <img
      src="/static/images/icon-no-data-chart.svg"
      class="bi-chart-empty__img"
      alt=""
    />
    <p class="bi-chart-empty__text">
      Não há dados suficientes para este período de análise.
    </p>
    <p class="bi-chart-empty__sub">Selecione outro período.</p>
  </div>
</template>

<script>
export default {
  name: 'BiChartEmpty',
}
</script>

<style scoped lang="scss">
.bi-chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  min-height: 280px;
  padding: 24px 16px;
  gap: 24px;

  &__img {
    width: 92px;
    height: 92px;
  }

  &__text {
    margin: 0;
    font-size: 14px;
    color: rgba(22, 22, 22, 1);
    text-align: center;
  }

  &__sub {
    margin: 0;
    font-size: 14px;
    color: rgba(22, 22, 22, 1);
    text-align: center;
  }
}
</style>
